var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineStrongbox2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 22.75c-5.43 0-7.75-2.32-7.75-7.75V9c0-5.43 2.32-7.75 7.75-7.75h6c5.43 0 7.75 2.32 7.75 7.75v6c0 5.43-2.32 7.75-7.75 7.75H9zM2.75 9v6c0 4.61 1.64 6.25 6.25 6.25h6c4.61 0 6.25-1.64 6.25-6.25V9c0-4.61-1.64-6.25-6.25-6.25H9C4.39 2.75 2.75 4.39 2.75 9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 19.75c-2.42 0-3.75-1.33-3.75-3.75V8c0-2.42 1.33-3.75 3.75-3.75h8c2.42 0 3.75 1.33 3.75 3.75v8c0 2.42-1.33 3.75-3.75 3.75H8zM5.75 8v8c0 1.58.67 2.25 2.25 2.25h8c1.58 0 2.25-.67 2.25-2.25V8c0-1.58-.67-2.25-2.25-2.25H8c-1.58 0-2.25.67-2.25 2.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15.25c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.48c.97 0 1.75-.79 1.75-1.75s-.79-1.75-1.75-1.75H5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2.48c1.79 0 3.25 1.46 3.25 3.25a3.25 3.25 0 0 1-3.25 3.25H5zM16 10.74c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3zM16 14.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3c.41 0 .75.34.75.75s-.34.75-.75.75h-3z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.87 12.92c-.12-.05-.23-.12-.33-.21a.99.99 0 0 1-.29-.71c0-.26.11-.52.29-.71.28-.27.72-.37 1.09-.21.13.05.24.12.33.21.18.19.29.45.29.71 0 .27-.1.52-.29.71-.1.09-.21.16-.33.21-.12.05-.25.08-.38.08s-.26-.03-.38-.08z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineStrongbox2);
export default __webpack_public_path__ + "static/media/vuesax-outline-strongbox-2.0fd77d189cfb6d3744fcf89ce0432c6a.svg";
export { ForwardRef as ReactComponent };